import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { SettingsFormState } from 'src/domains/players/webview/components/Account/preferencesTab/SettingsForm.state';
import {
    BalanceInHeaderWrapper,
    BalanceText,
    Header,
    OddsFormatWrapper,
    BalanceWrapper,
    BalanceInHeaderTitleWrapper,
} from './SettingsForm.style';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { useCommon } from 'src/domains/common/Common';
import { SelectNew } from '../../form/selectNew/SelectNew';
import { WalletIcon } from 'src/ui/assets/icons/currency/WalletIcon';
import { Toggle } from 'src/components/toggle/Toggle';
import { Separator } from './PreferencesTab.style';
import { BasicDataModel } from 'src/domains/players/state/BasicDataModel';

const SettingsForm = observer('SettingsForm', () => {
    const common = useCommon();
    const [state] = useState(() => new SettingsFormState(common));

    return (
        <>
            <OddsFormatWrapper data-test='odds-format'>
                <Header data-test='header'>
                    <I18n
                        langKey='account.contact-preferences-tab.settings-odds-format'
                        defaultText='Odds Format'
                    />
                </Header>
                <SelectNew
                    options={state.oddsFormatOptions}
                    inputState={state.oddsFormatInput}
                    onChange={(el) => {
                        state.updateOddsTypeIfChanged(el?.value);
                    }}
                    dataTest='select'
                />
            </OddsFormatWrapper>
            <Separator />
            <BalanceInHeaderWrapper>
                <BalanceInHeaderTitleWrapper>
                    <BalanceText data-test='balance-in-header'>
                        <I18n
                            langKey='account.contact-preferences-tab.settings-balance-in-header'
                            defaultText='Balance in header'
                        />
                    </BalanceText>
                    <BalanceWrapper>
                        <WalletIcon />
                        <BalanceText>{state.balance}</BalanceText>
                    </BalanceWrapper>
                </BalanceInHeaderTitleWrapper>
                <Toggle
                    dataTest='balance-in-header-toggle'
                    variant='light'
                    isActive={state.showBalanceInHeader}
                    toggleActive={state.updateBalanceInHeaderIfChanged}
                />
            </BalanceInHeaderWrapper>
            <Separator />
        </>
    );
});

export const SettingsFormWrapper = observer('SettingsFormWrapper', () => {
    const common = useCommon();
    const basicDataModel = BasicDataModel.get(common);

    if (basicDataModel.basicDataReady !== null) {
        return <SettingsForm />;
    }

    return null;
});
